import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchCards = (section) =>
  api.get(`/cards`, { params: section ? { section } : {} }).then((r) => r.data);

export const postNewsletter = (email) =>
  api.post(`/newsletter`, { email });

export const postContact = (payload) =>
  api.post(`/contact`, payload);
